import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-spring',
  standalone: true,
  imports: [],
  templateUrl: './spring.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './spring.component.scss'
})
export class SpringComponent {

}
